<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput :options="valueInput.options" :data="valueInput.data"/>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput :options="nameInput.options" :data="nameInput.data"/>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput :options="cmdInput.options" :data="cmdInput.data"/>
                </CCol>
<!--                <CCol xs="12" sm="12" md="6" xl="6">-->
<!--                  <BaseInput :options="htmlInput.options" :data="htmlInput.data"/>-->
<!--                </CCol>-->

              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData">
                  <i class="fa fa-save"></i> Lưu lại
                </CButton>
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "PiActionConfigUpdate",
  components: {BaseSelect, BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      idField: {
            data: {
            model: that.$route.params.id,
            name: "id",
            },
      },
      loading: {value: false},
      valueInput: {
        options: {
          label: "Mã thao tác <span class='required'>*</span>",
          placeholder: "Mã thao tác",
        },
        data: {
          name: "value",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.valueInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mã thao tác không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên thao tác <span class='required'>*</span>",
          placeholder: "Tên thao tác",
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên thao tác không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      cmdInput: {
        options: {
          label: "Câu lệnh <span class='required'>*</span>",
          placeholder: "Câu lệnh",
        },
        data: {
          name: "cmd",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.cmdInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Câu lệnh không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      htmlInput: {
        options: {
          label: "HTML",
          placeholder: "HTML",
        },
        data: {
          name: "html",
          model: "",
          updateCallback: function () {
            that.submitData();
          }
        }
      }
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/pi-action-config/update",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Cập nhật thao tác thành công"
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    loadData: function () {
      let that = this;
      that.loading.value = true;
      this.$helper.loadDataSource({
        url: "/pi-action-config/find-by-id",
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.$helper.setupDataResponse(that.$data, response.data.data);
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    }
  },
  computed: {},
  created() {
  },
  mounted() {
      this.loadData()
  },
  watch: {}
};
</script>
